module.exports = __webpack_public_path__ + "media/images/static/benefit/fig_merit3-1-de6d83d94c5bedeb21f7b0bd8d340215.png";